import axios from 'axios';
import { API_ROOT } from '../../config/api';

const sessionActions = {
  GET: 'SESSION_GET',
  GET_FAILED: 'SESSION_GET_FAILED',
  GET_SUCCESS: 'SESSION_GET_SUCCESS',
  JSC_SUCCESS: 'SESSION_JSC_SUCCESS',

  getFailed: (data) => ({
    payload: { data },
    type: sessionActions.GET_FAILED,
  }),
  getSession: (init = false) => ({
    payload: {
      init,
      request: () => axios.get(`${API_ROOT}/session`),
    },
    type: sessionActions.GET,
  }),
  getSuccess: (data) => ({
    payload: {
      data,
    },
    type: sessionActions.GET_SUCCESS,
  }),
  jscSuccess: (data) => ({
    payload: {
      data,
    },
    type: sessionActions.JSC_SUCCESS,
  }),
};

export default sessionActions;
